import React from 'react';

export const FallbackAttachment = ({ type, textContent }: { type: string, textContent?: string }) => (
    <div className="d-flex flex-column gap-1">
        <div className="d-flex align-items-center p-2 rounded gap-2" style={{ backgroundColor: 'rgba(0,0,0,0.05)' }}>
            <i className="ri-question-mark fs-20 text-muted"></i>
            <div className="text-muted" style={{ fontSize: '13px', fontStyle: 'italic' }}>
                Mensaje interactivo/sistema ({type})
            </div>
        </div>
        {textContent && <div className="text-break" style={{ whiteSpace: 'pre-wrap' }}>{textContent}</div>}
    </div>
);
